import { AWFMenu } from '@ansys-internal/awf-angular/core';
import { DriveCycleMoreMenuItem } from './more.menu';
import { ContributionsEnum } from '../../../contributions.enum';

@AWFMenu({
  id: ContributionsEnum.DRIVE_CYCLE_TABLE_MENU_ID,
  items: [DriveCycleMoreMenuItem],
})
export class DriveCycleTableMenu {}
